import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["range", "timeInputs", "beginTime", "endTime"];

  connect() {}

  handleStatusChange(e) {
    const allSameWeekdays = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")].filter(
      (row) => row.dataset.weekday === e.currentTarget.dataset.weekday
    );

    const isOpen = e.currentTarget.dataset.status === "open";
    const isOpenH24 = e.currentTarget.dataset.status === "openH24";
    const weekday = this.rangeTarget.dataset.weekday;
    const timeRangesController = this.application.getControllerForElementAndIdentifier(
      this.element.parentNode,
      "bo-nested-schedule-time-range"
    );

    allSameWeekdays.forEach((item, i) => {
      const timeInputs = item.querySelector(".time-inputs");
      if (!item) return;
      if (!timeInputs) return;
      if (isOpen) {
        this._toggleH24Checkbox(weekday, false);
        timeInputs.classList.remove("d-none");
        timeRangesController._showHideTimeRangHeader(weekday, false);
        timeInputs.parentNode.querySelector(".hidden-field").value = 0;
        this._setDefaultTimesValue(e.currentTarget.dataset.weekday);
      } else if (isOpenH24) {
        this._toggleH24Checkbox(weekday, true);
        timeInputs.classList.remove("d-none");
        timeRangesController._showHideTimeRangHeader(weekday, false);
        timeInputs.parentNode.querySelector(".hidden-field").value = 0;
        this._setTimesPickersToH24(e.currentTarget.dataset.weekday);
      } else {
        this._toggleH24Checkbox(weekday, true);
        timeInputs.classList.add("d-none");
        timeInputs.querySelector(".fa-xmark")?.classList.add("d-none");
        timeInputs.parentNode.querySelector(".add-range-container").innerHTML = "";
        timeInputs.parentNode.querySelector(".hidden-field").value = i === 0 ? "0" : "1";
        this.beginTimeTarget.value = null;
        this.endTimeTarget.value = null;
      }
    });
  }

  toggleH24value(e) {
    const weekday = e.target.dataset.weekday;
    if (e.target.checked) this._closeAllTimeranges(weekday);
    else this._toggleVisibilityTimepickers(weekday, false);
  }

  _closeAllTimeranges(weekday) {
    const loopOverRows = setInterval(() => {
      const rows = this._getVisibleRow(weekday);

      if (rows.length > 1) {
        const clickableRow = rows.find((item) => item.querySelector(".fa-xmark"));
        clickableRow.querySelector(".fa-xmark").dispatchEvent(new Event("click"));
      } else {
        this._setTimesPickersToH24(weekday);
        this._toggleVisibilityTimepickers(weekday, true);
        clearInterval(loopOverRows);
      }
    });
  }

  _toggleVisibilityTimepickers(weekday, hide, fromNested) {
    const parentDomElTimeinputs = fromNested
      ? [...fromNested.querySelectorAll(".time-inputs")]
      : [...this.rangeTarget.parentNode.querySelectorAll(".time-inputs")];
    const parentDomElAddBtns = fromNested
      ? [...fromNested.querySelectorAll(".add-range-container .btn")]
      : [...this.rangeTarget.parentNode.querySelectorAll(".add-range-container .btn")];

    const timeInputs = parentDomElTimeinputs.filter((row) => row.dataset.weekday === weekday);
    const addBtns = parentDomElAddBtns.filter((row) => row.dataset.weekday === weekday);

    if (hide) this._hidePickersAndAddBtn(weekday);
    else {
      [...addBtns][0].classList.toggle("d-none", hide);

      [...timeInputs].forEach((item) => {
        item.classList.toggle("d-none", hide);
        [...item.querySelectorAll(".schedules-time-input")].forEach((item) => this._setPickerValue(item));
      });

      if (timeInputs.length > 1) {
        timeInputs[0].querySelector(".fa-xmark").dispatchEvent(new Event("click"));
      }
    }
  }

  _hidePickersAndAddBtn(weekday) {
    this._getVisibleRow(weekday).forEach((item) => {
      item.querySelector(".time-inputs").classList.add("d-none");
      item.querySelector(".add-range-container .btn").classList.add("d-none");
    });
  }

  _getVisibleRow(weekday) {
    const timeranges = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")].filter(
      (row) => row.dataset.weekday === weekday && !row.classList.contains("d-none")
    );

    return timeranges
      .filter((tr) => !tr.querySelector(".time-inputs")?.classList.contains("d-none"))
      .filter((item) => item.querySelector(".fa-xmark"));
  }

  _toggleH24Checkbox(weekday, bool) {
    const h24 = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")]
      .filter((row) => row.dataset.weekday === weekday)
      .find((row) => row.dataset.index === "0")
      .querySelector(".h24");

    h24.classList.toggle("d-none", bool);
    if (!bool) h24.querySelector("input").checked = "";
  }

  _setTimesPickersToH24(weekday) {
    const rows = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")].filter(
      (row) => row.dataset.weekday === weekday
    );

    const visibles = [...rows].filter((item) => {
      return !item?.querySelector(".time-inputs")?.classList.contains("d-none");
    });

    visibles.forEach((item) => {
      [...item.querySelectorAll(".schedules-time-input")].forEach((item) => {
        this._setPickerValue(item, false, true);
      });
    });
  }

  _setDefaultTimesValue(weekday) {
    const firstPickerRow = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")]
      .filter((row) => row.dataset.weekday === weekday)
      .find((row) => row.dataset.index === "0");

    const othersPickersRows = [...this.rangeTarget.parentNode.querySelectorAll(".time-range-row")].filter(
      (row) => row.dataset.weekday === weekday && row.dataset.index !== "0"
    );

    [...othersPickersRows].forEach((item) => {
      item.querySelectorAll("input").forEach((item) => this._setPickerValue(item, true));
    });

    firstPickerRow.querySelectorAll("input").forEach((item) => this._setPickerValue(item));
  }

  _setPickerValue(item, isDefaultValue, h24) {
    if (item.id.includes("begin_time")) {
      item.value = isDefaultValue ? "" : h24 ? "00:00" : "09:00";
      item.nextElementSibling.value = isDefaultValue ? "" : h24 ? "00:00" : "09:00";
      item.nextElementSibling.placeholder = isDefaultValue ? "--:--" : h24 ? "00:00" : "09:00";
    }

    if (item.id.includes("end_time")) {
      item.value = isDefaultValue ? "" : h24 ? "23:59" : "18:00";
      item.nextElementSibling.value = isDefaultValue ? "" : h24 ? "23:59" : "18:00";
      item.nextElementSibling.placeholder = isDefaultValue ? "--:--" : h24 ? "23:59" : "18:00";
    }
  }
}
